import React from 'react';
import CalendarPeriodCells from './CalendarPeriodCells';
import { getYearPage, isSameYear, isYearOutOfRange } from '../../../utils/calendar';

const CalendarYears = ({ pageStart, selected, minDate, maxDate, onPick }) => {
  const today = new Date();

  return (
    <CalendarPeriodCells
      items={getYearPage(pageStart)}
      getLabel={(year) => year}
      getTestId={(year) => `calendar-year-${year}`}
      isCurrent={(year) => isSameYear(year, today)}
      isPicked={(year) => isSameYear(year, selected)}
      isDisabled={(year) => isYearOutOfRange(year, minDate, maxDate)}
      onPick={onPick}
    />
  );
};

export default CalendarYears;
